import React from 'react';
import AppModal from '../common/AppModal';

const WIRE_TRANSFER_DETAILS = [
  { label: 'Bank Name', value: 'Wells Fargo' },
  { label: 'Bank Address', value: '8400 NW 36 St Suite 450\nMiami, FL 33166' },
  { label: 'Account Name', value: 'Accurate Lien Search LLC' },
  { label: 'Account Number', value: '2575092818' },
  { label: 'ABA Number', value: '121000248' },
  { label: 'Routing #', value: '063107513' },
  { label: 'SWIFT #', value: 'WFBIUS6S' }
];

const WireInformationModal = ({ show, onHide }) => (
  <AppModal
    show={show}
    onHide={onHide}
    onSubmit={onHide}
    heading="Wire Information"
    submitLabel="Close"
    showCancelButton={false}
    submitButtonVariant="secondary"
  >
    <p className="text-muted smallFont mb-3">
      Use the details below for wire transfer payments to Accurate Lien Search.
    </p>
    <div className="bg-light" style={{ padding: '20px 25px', borderRadius: 16 }}>
      {WIRE_TRANSFER_DETAILS.map(({ label, value }, index) => (
        <div
          key={label}
          className={`d-flex justify-content-between align-items-start py-2${
            index < WIRE_TRANSFER_DETAILS.length - 1 ? ' border-bottom' : ''
          }`}
        >
          <span className="text-muted xsmallFont flex-shrink-0 mr-3">{label}</span>
          <span className="text-dark font-weight-bold text-right xsmallFont">
            {value.split('\n').map((line, lineIndex) => (
              <React.Fragment key={`${label}-${lineIndex}`}>
                {lineIndex > 0 && <br />}
                {line}
              </React.Fragment>
            ))}
          </span>
        </div>
      ))}
    </div>
  </AppModal>
);

export default WireInformationModal;
